import cookies from "js-cookie";

export const clearLegacyCookieConsentPopupCookieValueIfExists = () => {
  const cookieName = "cookie-consent-key";
  const cookieValue = cookies.get(cookieName);
  if (cookieValue) {
    cookies.remove(cookieName);
  }
};
